const colors =
{
    dark10: '#1a1a1a',
    dark15: '#262626',
    dark20: '#333333',
    dark25: '#404040',
    dark30: '#4d4d4d',
    dark40: '#666666',
    dark50: '#808080',
    dark60: '#999999',
    dark70: '#b3b3b3',
    dark80: '#cccccc',
    dark90: '#e6e6e6',
    accentGreen1: '#65ffa0',
    accentGreen2: '#76ff03',
    accentGreen3: '#aeea00',
    accentGreen4: '#64ffda',
    accentRed1: '#ff5252',
    accentRed2: '#d50000',
    accentRed3: '#dd2c00',
    accentPurple1: '#e040fb',
    accentPurple2: '#aa00ff',
    accentPurple3: '#7c4dff',
    accentBlue1: '#6200ea',
    accentBlue2: '#536dfe',
    accentBlue3: '#304f9a',
    accentBlue4: '#448aff',
    accentBlue5: '#2962ff',
    accentYellow1: '#ffff00',
    accentYellow2: '#ffd740',
    accentOrange1: '#ff8c40',
    accentOrange2: '#ff6d00',
    accentOrange3: '#ff5d2a',
    accentPink1: '#ff4081',
    accentPink2: '#c51162',
    accentLightBlue1: '#40c4ff',
    accentLightBlue2: '#18ffff'
};

const colorArray =
[
    colors.accentRed1,
    colors.accentBlue1,
    colors.accentOrange1,
    colors.accentPurple1,
    colors.accentLightBlue1,
    colors.accentPurple2,
    colors.accentYellow2
];

const accentColor = colors.accentPink1;

export { colors, colorArray, accentColor }